var utils = require("./utils");

$.fn.tableDeadlineSubmission = function () {
  if (this.length) {
    var $srcElement = $(this);
    var $content = $srcElement.children("tbody");

    var $hiddenInput = $(".js-deadline-submission");
    var dealineSubmissionObject = {};

    $srcElement.find(".js-add").click(addClickEvent);

    var orgIds = [];
    $("#orgName option").each(function () {
      orgIds.push($(this).attr("value"));
    });

    var orgNames = [];
    $("#orgName option").each(function () {
      orgNames.push($(this).text());
    });

    var fileReader = new FileReader();
    $("#chooseFile").css("margin-right", "30px");

    $("#fileUpload").on("click", function () {
      var csv = $("#fileInput").val();
      if (typeof csv[0] === "undefined") {
        $("#message").text("");
        $("#fileError").text("Please provide a file to upload");
      } else {
        if (!csv.endsWith(".csv")) {
          $("#message").text("");
          $("#fileError").text("The selected file must be a CSV. Check the file type and try again.");
        } else {
          fileReader.onload = function () {
            var data = fileReader.result; // file data in Base64 format
            var rows = data.split("\r\n");
            for (var i = 1; i < rows.length; i++) {
              if (rows[i].length == 0) {
                rows = jQuery.grep(rows, function (value) {
                  return value != rows[i];
                });
              }
            }
            var orgIdCols = [""];
            var orgNameCols = [""];
            var columns = [];
            for (var i = 1; i < rows.length; i++) {
              if (rows[i].indexOf('"') > -1) {
                columns.push(rows[i].match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g));
                for (var i = 0; i < columns.length; i++) {
                  if (columns[i][1].indexOf('"') >= 0) {
                    columns[i][1] = columns[i][1].replace(/"/g, "");
                  }
                }
              } else {
                columns.push(rows[i].split(","));
              }
            }
            for (var i = 0; i < columns.length; i++) {
              orgIdCols.push(columns[i][0]);
              orgNameCols.push(columns[i][1]);
            }
            if (
              rows[0] ===
                "organisation-id,organisation-name,new-deadline-date,extension-reason" &&
              rows.length > 0 &&
              idArraysEqualOrNot(orgIdCols, orgIds) &&
              nameArraysEqualOrNot(orgNameCols, orgNames)
            ) {
              for (var i = 0; i < columns.length; i++) {
                addDataFromCsv(columns[i]);
              }
              $("#fileError").text("");
              $("#message").text("File uploaded successfully");
              $("#fileInput").val("");
              $(".file-upload-container input").attr(
                "placeholder",
                "No file chosen",
              );
              $(".file-upload-container input").val("");
            } else {
              $("#message").text("");
              $("#fileError").text(
                "The csv is not formatted correctly. Please download the the submission deadline extension template using the link below.",
              );
              $("#fileInput").val("");
              $(".file-upload-container input").attr(
                "placeholder",
                "No file chosen",
              );
              $(".file-upload-container input").val("");
            }
          };
          fileReader.readAsBinaryString($("#fileInput").prop("files")[0]);
        }
      }
    });

    storeExistingDomContent();
    renderContent();
    updateHiddenInput();
    updateSelect();
  }

  function idArraysEqualOrNot(uploadedOrgIds, currentOrgIds) {
    var orgIdstatus;
    if (uploadedOrgIds.length > 0 && currentOrgIds.length > 0) {
      for (var i = 1; i < uploadedOrgIds.length; i++) {
        orgIdstatus = false;
        for (var j = 1; j < currentOrgIds.length; j++) {
          if (uploadedOrgIds[i] == currentOrgIds[j]) {
            orgIdstatus = true;
          }
        }
        if (orgIdstatus == false) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }
  function nameArraysEqualOrNot(uploadedOrgNames, currentOrgNames) {
    var orgNameStatus;
    if (uploadedOrgNames.length > 0 && currentOrgNames.length > 0) {
      for (var i = 1; i < uploadedOrgNames.length; i++) {
        orgNameStatus = false;
        for (var j = 1; j < currentOrgNames.length; j++) {
          if (uploadedOrgNames[i] == currentOrgNames[j]) {
            orgNameStatus = true;
          }
        }
        if (orgNameStatus == false) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }

  function storeExistingDomContent() {
    var obj = getExistingDomContent();
    addToDealineSubmissionObject(obj);
  }

  function resetInputs() {
    $($srcElement.find(":text").not(":hidden")).val("");

    var orgText = $("#orgName option:selected").text();
    var orgValue = $("#orgName option:selected").val();
    var newOrg = $('<option value="' + orgValue + '">' + orgText + "</option>");
    $("#orgName option:selected").empty();
    $("#orgName").append(newOrg);
    $("#orgName").trigger("chosen:updated");

    var reasonText = $("#extensionReason option:selected").text();
    var reasonValue = $("#extensionReason option:selected").val();
    var newReason = $(
      '<option value="' + reasonValue + '">' + reasonText + "</option>",
    );
    $("#extensionReason option:selected").empty();
    $("#extensionReason").append(newReason);
    $("#extensionReason").trigger("chosen:updated");
  }

  function updateSelect() {
    var $select = $srcElement.find("select#orgName");

    $.ajax({
      url: $select.data("url"),
      data: "",
      dataType: "json",
      type: "get",
      success: function (data) {
        var options = [];

        for (var key in data) {
          options.push(
            '<option value="' + key + '">' + data[key] + "</option>",
          );
        }

        $select.append(options.join(""));
      },
    });
  }

  function updateHiddenInput() {
    $hiddenInput.val(JSON.stringify(mapObject(dealineSubmissionObject)));
  }

  function getExistingDomContent() {
    var obj = {};
    $($content)
      .find("tr")
      .each(function () {
        var id = $(this).attr("id");
        var $td = $("td", this);
        obj[id] = {};
        obj[id].name = $td.eq(0).text();
        obj[id].date = $td.eq(1).text();
        obj[id].reason = $td.eq(2).text();
      });

    return obj;
  }

  function mapObject(data) {
    var obj = { submissionDeadlineExtension: [] };

    for (var key in data) {
      var item = {};
      item["extension-organisation-id"] = key;
      item["extension-organisation-name"] = data[key].name;
      item["extended-submission-deadline-date"] =
        formatDate(data[key].date) + "T00:00:00Z";
      item["extension-reason"] = data[key].reason;
      obj.submissionDeadlineExtension.push(item);
    }

    return obj;
  }

  function formatDate(value) {
    return utils.convertDateFormat(value, "YYYY-MM-DD");
  }

  function addClickEvent(e) {
    e.preventDefault();
    var newDataObject = getDataInput();
    if (newDataObject) {
      addToDealineSubmissionObject(newDataObject);
      renderContent();
      updateHiddenInput();
      resetInputs();
    }
  }

  function addDataFromCsv(csvData) {
    var newDataObject = getData(csvData);
    if (newDataObject) {
      addToDealineSubmissionObject(newDataObject);
      renderContent();
      updateHiddenInput();
    }
  }

  function getData(csvData) {
    var orgId = csvData[0];
    var orgName = csvData[1];
    var date = csvData[2];
    var reason;
    if (csvData[3] == undefined) {
      reason = "";
    } else {
      reason = csvData[3].replace(/"/g, "");
    }

    var obj = {};

    if (orgId !== "" && date !== "") {
      obj[orgId] = {};
      obj[orgId].name = orgName;
      obj[orgId].date = date;
      obj[orgId].reason = reason;

      return obj;
    }
    return false;
  }

  function removeClickEvent(e) {
    removeFromDeadlineSubmissionObject($(e.target).data("orgid"));
    renderContent();
    updateHiddenInput();
  }

  function addToDealineSubmissionObject(obj) {
    $.extend(dealineSubmissionObject, obj);
  }

  function removeFromDeadlineSubmissionObject(key) {
    delete dealineSubmissionObject[key];
  }

  function getDataInput() {
    var orgId = $("#orgName").val();
    var orgName = $("#orgName option:selected").text();
    var reason = $("#extensionReason option:selected").text();
    var date = $("#extendedDeadlineDate").val();

    var obj = {};

    if (orgId !== "" && date !== "") {
      obj[orgId] = {};
      obj[orgId].name = orgName;
      obj[orgId].date = date;
      obj[orgId].reason = reason;
      return obj;
    }

    return false;
  }

  function renderContent() {
    $srcElement.children("tbody").replaceWith(getTbody());
  }

  function getTbody() {
    var obj = dealineSubmissionObject;
    var $content = $("<tbody />");
    var $link;

    $.each(obj, function (key, value) {
      $link = $(
        '<td class="govuk-table__cell"><button type="button" class="js-remove" data-orgid="' +
          key +
          '">remove</button></td>',
      ).on("click", removeClickEvent);

      var $row = $('<tr class="govuk-table__row"/>')
        .append('<td class="govuk-table__cell">' + obj[key].name + "</td>")
        .append('<td class="govuk-table__cell">' + obj[key].date + "</td>")
        .append('<td class="govuk-table__cell">' + obj[key].reason + "</td>")
        .append($link);

      $content.append($row);
    });

    return $content;
  }
};
